var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHenLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 108.725,
    height: 39.668,
    viewBox: "0 0 108.725 39.668",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_30372",
    "data-name": "Group 30372",
    transform: "translate(8632.168 7817)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_141730",
    "data-name": "Path 141730",
    d: "M138.108,37.829V5.674a.169.169,0,0,0-.168-.169h-6.127a.169.169,0,0,0-.168.169v16.2l-.013-.012c-5.145-4.474-12.051-5.333-16.337-5.374V5.674a.169.169,0,0,0-.168-.169H109a.169.169,0,0,0-.168.169V39.5a.168.168,0,0,0,.168.168h6.127a.168.168,0,0,0,.168-.168V22.958c3.282.034,8.5.643,12.117,3.8,2.789,2.443,4.217,6.166,4.233,11.062V39.5a.168.168,0,0,0,.168.168h6.127a.168.168,0,0,0,.168-.168V37.9h0v-.074",
    transform: "translate(-8741 -7817)",
    fill: "#0d1624"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_141732",
    "data-name": "Path 141732",
    d: "M169.733,11.785a.168.168,0,0,0,.168-.168V5.664a.168.168,0,0,0-.168-.168H144.451a.168.168,0,0,0-.168.168V39.5a.168.168,0,0,0,.168.168h25.282a.168.168,0,0,0,.168-.168V33.83a.168.168,0,0,0-.168-.168H150.794c.2-1.983,1.311-5.427,7.575-7.618a32.11,32.11,0,0,1,8.864-1.6.164.164,0,0,0,.16-.166l-.042-6.131h0a.167.167,0,0,0-.168-.166c-4.591.055-11.424,1.263-16.432,4.727V11.785Z",
    transform: "translate(-8741 -7817)",
    fill: "#0d1624"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_141734",
    "data-name": "Path 141734",
    d: "M205.224,5.5H199.1a.168.168,0,0,0-.168.168v27.1c-5.54-.705-9.468-6.371-11.84-11.441a50.9,50.9,0,0,1-4.525-15.682A.166.166,0,0,0,182.4,5.5h-6.149a.168.168,0,0,0-.168.168V39.5a.168.168,0,0,0,.168.168h6.085a.169.169,0,0,0,.169-.168V26.645c3.65,6.709,9,12.474,16.425,13.018h6.3a.168.168,0,0,0,.168-.168V5.67a.168.168,0,0,0-.168-.168",
    transform: "translate(-8741 -7817)",
    fill: "#0d1624"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_141735",
    "data-name": "Path 141735",
    d: "M211.057,3.566h-.6V.522h-1.309V0h3.216V.522h-1.309Z",
    transform: "translate(-8741 -7817)",
    fill: "#0d1624"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_141736",
    "data-name": "Path 141736",
    d: "M215.291,3.566l-.976-1.886c-.113-.321-.207-.6-.283-.869.019.315.032.655.032.919V3.566H213.5V0h.736l1.045,2.056c.132.365.151.409.252.742.126-.377.176-.516.251-.73L216.821.019h.736V3.566h-.566V1.731c0-.29.012-.592.031-.919-.1.34-.176.579-.308.919l-.955,1.835Z",
    transform: "translate(-8741 -7817)",
    fill: "#0d1624"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHenLogo);
export default __webpack_public_path__ + "static/media/hen-logo.c5ba9596ce6f83670021a93862fee01a.svg";
export { ForwardRef as ReactComponent };